
// API 地址映射表
export const API_URL_MAP = {
  // 示例映射关系，请根据实际需求修改
  '/api/app/config/system_webConfig': '/api/getSystemWebConfig_no?name=system_webConfig',
  '/api/app/config/other_setting':'/api/getSystemWebConfig_no?name=other_setting',
  '/api/app/packageCourseClassify/index':'/api/app/packagecourse_cate_son_list', //获取课时包分类
  '/api/app/packageCourse':'/api/app/package_course_index'
};